var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58 29C58 30.3833 57.9032 31.7439 57.7158 33.0756C56.3061 43.0987 49.7724 51.4774 40.8486 55.477C37.231 57.0984 33.2208 58 29 58C12.9838 58 0 45.0162 0 29C0 12.9838 12.9838 0 29 0C45.0162 0 58 12.9838 58 29Z",
    fill: "#942FFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7159 33.0758C56.3063 43.0989 49.7726 51.4776 40.8487 55.4772L25.3965 40.0249L45.0308 20.3906L57.7159 33.0758Z",
    fill: "#5400AA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7834 22.1483C41.9059 28.0203 37.0286 33.8922 32.1511 39.7642C29.9502 35.6101 27.7494 31.4562 25.5488 27.3021C27.9005 20.8649 30.2521 14.4274 32.6037 7.99023C37.3302 12.7096 42.0569 17.4287 46.7834 22.148V22.1483Z",
    fill: "#5400AA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6038 17.7754V7.99023H25.3965V17.7754V24.9824V40.0218H32.6038V24.9824V17.7754Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4372 54.1563C40.3308 55.943 36.8621 57.1707 33.1686 57.7022L25.9102 50.4438L26.5105 49.8432L26.2974 49.6302L32.6041 43.3232L43.4372 54.1563Z",
    fill: "#5400AA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5108 49.8439L25.9105 50.4444L25.6973 50.2312L26.2978 49.6309L26.5108 49.8439Z",
    fill: "#5400AA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5101 49.8433L25.9098 50.4439L25.909 50.4444L25.3965 49.9321L25.9978 49.3311L26.5101 49.8433Z",
    fill: "#5400AA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6035 43.3232H25.3965V49.9308H32.6035V43.3232Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.0387ad14.svg";
export { ForwardRef as ReactComponent };